import React from "react";
import BaseTextButton from "../BaseTextButton";
import PropTypes from "prop-types";
import "./style.scss";
import i18n from "i18next";
export default function BaseExitButton({
  label = i18n.t("exit"),
  onClick,
  className,
  to,
}) {
  BaseExitButton.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    to: PropTypes.string,
    onClick: PropTypes.func,
  };
  const cls = ["btn-logout"];
  if (className) cls.push(className);
  return (
    <BaseTextButton
      icon="logout"
      onClick={onClick}
      iconStyle="icon-lines"
      to={to}
      className={cls.join(" ")}
      iconWrapperStyle="exit-icon-wrapper"
    >
      {label}
    </BaseTextButton>
  );
}
